/* eslint-disable no-unused-vars */
import { useState, useCallback } from 'react';

const useRerender = () => {
  const [, setState] = useState(0);
  return useCallback(() => setState((state) => state + 1), []);
};

export const useToggleState = (initalDataArr = []) => {
  const [stateSet] = useState(() => new Set(initalDataArr));
  const state = [...stateSet.values()];

  const rerender = useRerender();

  const isActive = useCallback((groupName) => stateSet.has(groupName), [stateSet]);

  const toggle = useCallback(
    (...stateItems) => {
      stateItems.forEach((stateItem) => {
        return isActive(stateItem) ? stateSet.delete(stateItem) : stateSet.add(stateItem);
      });
      rerender();
    },
    [isActive],
  );
  const toggleOn = useCallback(
    (...stateItems) => {
      toggle(...stateItems.filter((stateItem) => !stateSet.has(stateItem)));
    },
    [toggle],
  );
  const toggleOff = useCallback(
    (...stateItems) => {
      toggle(...stateItems.filter((stateItem) => stateSet.has(stateItem)));
    },
    [toggle],
  );
  return { state, isActive, toggle, toggleOn, toggleOff };
};
